<template>
	<div class="simple-modal-wrapper">
		<div class="simple-modal">
			<button
				class="simple-modal__close"
				aria-label="Close modal"
				@click="closeModal"
			/>
			<div class="simple-modal__content">
				<h2 class="simple-modal__heading">
					{{ heading }}
				</h2>

				<slot name="content" />

				<div class="simple-modal__buttons">
					<slot name="buttons" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>

import { defineEmits, defineProps } from 'vue';

const props = defineProps( {
	heading: { type: String, required: true }
} );

const emit = defineEmits( ['close-modal'] );

const closeModal = () => { // eslint-disable-line snakecasejs/snakecasejs
	emit( 'close-modal' );
};
</script>